import Box from "@mui/material/Box";
import { useAuth } from "../../../providers/auth";
import Modal from 'react-bootstrap/Modal';

interface ITermos {
  modal: boolean;
  setModal: (val: boolean) => void;
  agree?: () => void;
  disagree?: () => void;
}

const Termos = ({ modal, setModal, agree, disagree }: ITermos) => {
  const { token } = useAuth();

  return (
    <Modal
      show={modal}
      size="lg"
      onHide={() => setModal}
      backdrop="static"
      keyboard={false}
      className="text-body"
      centered
      scrollable
    >
      <div className="modal-header">
        <h5 className="modal-title">
          <i className="las la-file-contract me-3"></i>
          Termos de Uso
          <p className="mb-0 fs-6 fw-normal">Atualizado em 26/07/2022</p>
        </h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => setModal(false)}
        ></button>
      </div>
      <div className="modal-body bg-light text-body">
        <div
          style={{ maxHeight: "50vh", overflowY: "auto" }}
          className="px-2"
        >
          <p>Caro Usuário,</p>
          <p>
            O Brasil, desde o ano de 2018, possui uma Lei específica para
            regulamentar a proteção de dados pessoais e dados pessoais
            sensíveis da população. Trata-se da Lei nº 13.709/2018, mais
            conhecida como LGPD.
          </p>
          <p>A Lei divide os dados em 2 modalidades distintas:</p>
          <ul>
            <li>
              Dado pessoal: informação relacionada à pessoa natural
              identificada ou identificável; encaixa-se nessa modalidade,
              por exemplo, o nome, RG, CPF e endereço.
            </li>
            <li>
              Dado pessoal sensível: dado pessoal sobre origem racial ou
              étnica, convicção religiosa, opinião política, filiação a
              sindicato ou à organização de caráter religioso, filosófico
              ou político, dado referente à saúde ou à vida sexual, dado
              genético ou biométrico, quando vinculado a uma pessoa
              natural.
            </li>
          </ul>
          <p>
            Ainda, a lei prevê a possibilidade de transformar um dado
            pessoal ou dado pessoal sensível em um dado anonimizado, ou
            seja, um dado em que não se pode identificar o seu titular.
          </p>
          <p>
            E dispõe também sobre as regras específicas para realização de
            tratamento de cada uma das modalidades de dados. O tratamento,
            segundo a Lei, se refere a "toda operação realizada com dados
            pessoais, como as que se referem a coleta, produção, recepção,
            classificação, utilização, acesso, reprodução, transmissão,
            distribuição, processamento, arquivamento, armazenamento,
            eliminação, avaliação ou controle da informação, modificação,
            comunicação, transferência, difusão ou extração".
          </p>
          <p>
            Nossa plataforma, em função de sua natureza e finalidade
            relacionada à telemedicina, promove o tratamento de dados
            pessoais e dados pessoais sensíveis dos usuários.{" "}
          </p>
          <p>
            Entendemos que é muito importante que você tenha conhecimento
            das atividades de tratamento que são realizadas e também que
            concorde com esse tratamento, para que não tenhamos problemas
            futuramente.{" "}
          </p>
          <p>
            Como a nossa plataforma contempla diferentes serviços na área
            de saúde, as modalidades de tratamentos de dados que serão
            realizados dependem de qual é o serviço contratado pelo
            usuário.
          </p>
          <p>
            Para os usuários que se cadastraram diretamente na plataforma,
            as atividades de tratamento realizadas pela plataforma são as
            seguintes:
          </p>
          <ol>
            <li>
              Coleta e armazenamento de dados pessoais do usuário da
              plataforma;
            </li>
            <li>
              Armazenamento de dados pessoais sensíveis relacionados ao
              quadro de saúde do usuário da plataforma, anotados pelo(s)
              profissional(is) médico(s) em seus respectivos prontuários;
            </li>
            <li>
              Armazenamento de arquivos criptografados contendo as
              gravações das teleconsultas realizadas pelo usuário na
              plataforma;
            </li>
            <li>
              Compartilhamento da gravação da teleconsulta exclusivamente
              com o médico responsável pelo atendimento;
            </li>
            <li>
              Compartilhamento de dados pessoais e de dados pessoais
              sensíveis relacionados ao quadro de saúde do usuário da
              plataforma (prontuário) com profissionais médicos
              (exclusivamente aqueles que possuem relação médico-paciente
              com o usuário);
            </li>
          </ol>
          <p>
            Já para os usuários incluídos na plataforma através da
            contratação de nossos serviços pelos empregadores, as
            atividades de tratamento realizadas pela plataforma são as
            seguintes:
          </p>
          <ol>
            <li>
              Coleta e armazenamento de dados pessoais do usuário da
              plataforma;
            </li>
            <li>
              Armazenamento de dados pessoais sensíveis relacionados ao
              quadro de saúde do usuário da plataforma, anotados pelo(s)
              profissional(is) de saúde nos atendimentos realizados;
            </li>
            <li>
              Armazenamento de arquivos criptografados contendo as
              gravações das teleconsultas realizadas pelo usuário na
              plataforma;
            </li>
            <li>
              Compartilhamento da gravação da teleconsulta exclusivamente
              com o médico responsável pelo atendimento;
            </li>
            <li>
              Compartilhamento de dados pessoais e de dados pessoais
              sensíveis relacionados ao quadro de saúde do usuário da
              plataforma exclusivamente com outros profissionais de saúde
              que componham o grupo responsável pelos cuidados digitais na
              área de saúde dos empregados;
            </li>
          </ol>
          <p>
            Para este grupo específico de usuários, considerando que um
            dos objetivos do serviço contratado pelos empregadores é ter
            acesso a um panorama geral sobre a saúde de seus empregados
            (seja ela de natureza física, mental, entre outras), os dados
            pessoais sensíveis relacionados ao quadro de saúde serão
            anonimizados (tornados anônimos, ou seja, sem possibilidade de
            ligação entre os dados e seu titular), compilados com os dados
            pessoais sensíveis dos demais usuários (podem ser membros de
            equipe, membros do setor ou mesmo de toda empresa) e
            apresentados ao empregador em forma de relatório.
          </p>
          <p>
            Esse estudo, extremamente positivo, visa possibilitar que o
            empregador conduza analises sobre possíveis medidas que podem
            ser adotadas com vistas a auxiliar os empregados na manutenção
            e/ou melhoria de sua saúde.
          </p>
          <p>
            Igualmente, entendemos que é relevante que todos saibam que a
            plataforma também opera mediante agendamentos ativos
            promovidos pelas equipes de saúde e com envio e recebimento de
            mensagens digitais aos usuários (e-mails, mensagens
            instantâneas, alertas e notificações).{" "}
          </p>
          <p>
            Ainda, é importante que todos tenham conhecimento que a Lei
            afasta a necessidade de consentimento específico do usuário
            para fins de tratamento de dados pessoais sensíveis nas
            seguintes hipóteses:
          </p>
          <ol>
            <li>
              Cumprimento de obrigação legal ou regulatória por parte da
              plataforma;
            </li>
            <li>
              Execução de políticas públicas por parte da administração
              pública;
            </li>
            <li>
              Realização de estudos por órgão de pesquisa; nesta hipótese,
              caso aplicável, será dada prioridade para compartilhamento
              de dados anonimizados, ou seja, em que não é possível
              vincular a informação ao seu titular;
            </li>
            <li>
              Exercício regular de direitos em âmbito contratual,
              judicial, administrativo ou arbitral;
            </li>
            <li>
              Proteção da vida ou da incolumidade física do titular ou de
              terceiros;
            </li>
            <li>
              Tutela da saúde, exclusivamente, em procedimento realizado
              por profissionais de saúde, serviços de saúde ou autoridade
              sanitária;
            </li>
          </ol>
          <p>
            Por fim, a LGPD, em seu artigo 18, apresenta o rol de direitos
            dos titulares de dados:
          </p>
          <p>
            {" "}
            Art. 18. O titular dos dados pessoais tem direito a obter do
            controlador, em relação aos dados do titular por ele tratados,
            a qualquer momento e mediante requisição:
          </p>
          <ul style={{ listStyle: "lower-roman" }}>
            <li>confirmação da existência de tratamento;</li>
            <li>acesso aos dados;</li>
            <li>
              correção de dados incompletos, inexatos ou desatualizados;
            </li>
            <li>
              anonimização, bloqueio ou eliminação de dados
              desnecessários, excessivos ou tratados em desconformidade
              com o disposto nesta Lei;
            </li>
            <li>
              portabilidade dos dados a outro fornecedor de serviço ou
              produto, mediante requisição expressa e observados os
              segredos comercial e industrial, de acordo com a
              regulamentação do órgão controlador;
            </li>
            <li>
              portabilidade dos dados a outro fornecedor de serviço ou
              produto, mediante requisição expressa, de acordo com a
              regulamentação da autoridade nacional, observados os
              segredos comercial e industrial;
            </li>
            <li>
              eliminação dos dados pessoais tratados com o consentimento
              do titular, exceto nas hipóteses previstas no art. 16 desta
              Lei;
            </li>
            <li>
              informação das entidades públicas e privadas com as quais o
              controlador realizou uso compartilhado de dados;
            </li>
            <li>
              informação sobre a possibilidade de não fornecer
              consentimento e sobre as consequências da negativa;
            </li>
            <li>revogação do consentimento.</li>
          </ul>
          <p>
            Ao dar aceite neste Termo, consideramos que você está de
            acordo com a nossa Política de Privacidade, disponível em
            https://conectadoc.com.br/PoliticaPrivacidade.aspx.
          </p>
          <p>
            Estamos à disposição de todos os usuários para auxiliá-los no
            tocante aos direitos elencados na Lei e também sobre eventuais
            dúvidas.
          </p>
          <p>Equipe ConectaDoc.</p>
        </div>
      </div>
      {!token && (
        <div className="modal-footer">
          <a
            className="btn btn-md btn-outline-danger"
            onClick={disagree}
          >
            Não concordo
          </a>
          <a className="btn btn-md btn-success" onClick={agree}>
            Li e concordo com os termos de uso
          </a>
        </div>
      )}
    </Modal>
  );
};

export default Termos;
